export const WORK_CONDITIONS_CHANGE_REQUESTS_PATH =
  "/requests/work-conditions-change";
